import { all } from "redux-saga/effects";
import logInSaga from "../redux/Login/saga";
import otpSaga from "./Otp/saga";
import myDonations from "../redux/myDonations/saga";
import donorPersonalDetails from "../redux/donorDetails/saga";
import studentDetails from "../redux/studentDetails/saga";
import Examination from "../redux/examination/saga";
import getDetailsSaga from "../redux/examdashboard/saga"
import getTeamsaga from "../redux/createteam/saga"

export default function* rootSaga() {
  yield all([
    logInSaga(),
    otpSaga(),
    donorPersonalDetails(),
    myDonations(),
    studentDetails(),
    Examination(),
    getDetailsSaga(),
    getTeamsaga()
  ]);
}
